import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  CardMedia,
  Grid
} from '@mui/material';

const PhotoGallery = ({ photos, salonName, isMobile = false }) => {
  if (!photos || photos.length <= 1) {
    return null;
  }

  const galleryPhotos = photos.slice(1);

  if (isMobile) {
    return (
      <Box sx={{ mt: 3 }}>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: '#000000' }}>
          Galerie photos
        </Typography>
        
        <Box sx={{ 
          display: 'flex', 
          gap: 2, 
          overflowX: 'auto', 
          pb: 1,
          '&::-webkit-scrollbar': {
            height: 4,
          },
          '&::-webkit-scrollbar-track': {
            backgroundColor: '#E5E7EB',
            borderRadius: 2,
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#6B7280',
            borderRadius: 2,
          }
        }}>
          {galleryPhotos.map((photo, index) => (
            <Box
              key={index}
              component="img"
              src={photo}
              alt={`Photo ${index + 2}`}
              sx={{
                width: 120,
                height: 120,
                borderRadius: 2,
                objectFit: 'cover',
                flexShrink: 0,
                border: '1px solid #E5E7EB'
              }}
            />
          ))}
        </Box>
      </Box>
    );
  }

  // Desktop version
  return (
    <Grid item xs={12}>
      <Card>
        <CardContent>
          <Typography variant="h5" gutterBottom>
            Galerie photos
          </Typography>
          
          <Grid container spacing={2}>
            {galleryPhotos.map((photo, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <CardMedia
                  component="img"
                  height="200"
                  image={photo}
                  alt={`Photo ${index + 2}`}
                  sx={{ borderRadius: 1, objectFit: 'cover' }}
                />
              </Grid>
            ))}
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default PhotoGallery;